/* Kerastinni — vídeos de review: autoplay mudo na rolagem, tela cheia com som ao tocar */
(function () {
  function init() {
    var box = document.querySelector('[data-kr-reviews]:not([data-kr])');
    if (!box) return;
    box.setAttribute('data-kr', '1');
    var items = box.querySelectorAll('.kr-reviews__item');
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target.querySelector('video');
        if (!v) return;
        if (e.isIntersecting) {
          if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }, { threshold: 0.35 }) : null;
    items.forEach(function (it) { if (io) io.observe(it); });

    var modal = document.querySelector('[data-kr-modal]');
    if (!modal) return;
    var player = modal.querySelector('.kr-reviews__player');
    function open(src) {
      player.src = src; modal.hidden = false; document.body.style.overflow = 'hidden';
      var p = player.play(); if (p && p.catch) p.catch(function () {});
    }
    function close() {
      player.pause(); player.removeAttribute('src'); player.load();
      modal.hidden = true; document.body.style.overflow = '';
    }
    items.forEach(function (it) { it.addEventListener('click', function () { open(it.getAttribute('data-kr-src')); }); });
    modal.querySelectorAll('[data-kr-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    var buy = modal.querySelector('[data-kr-buy]');
    if (buy) buy.addEventListener('click', function () {
      close();
      var btn = document.querySelector('.product-form__add-button');
      if (btn) { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { btn.click(); }, 350); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('cart:refresh', init);
})();
